import { Box, Typography } from "@mui/material";
import React from "react";
import CommonButton from "../../../../component/Button";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomizeSpan } from "../../../jobs/style";
import FileUpload from "../../../matches/quick-match/components/FileUpload";
import TrialLoading from "../../../../assets/gif/Trailloading.gif";

export default function GrowthAgentFileUpload({
  onDragOver,
  onDragLeave,
  onDrop,
  isDragging,
  onChange,
  localStorageData,
  handleAnalyzeClick,
  klarityData,
  files,
  handleDeleteFile,
}) {
  return (
    <CustomDiv padding="2rem">
      <CommonGrid2 container spacing={2} alignItems="center">
        <CommonGrid2 item size={12}>
          <Typography variant="h1">Growth Agent</Typography>
          <Typography fontSize={"15px"} marginTop={"1rem"} color="#475467">
            All your data, insights and opportunity to drive impact
          </Typography>
        </CommonGrid2>
      </CommonGrid2>
      {klarityData.data_status?.status &&
      klarityData.data_status?.status === "in_progress" ? (
        <CommonGrid2
          height={"calc(100vh - 10rem)"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
        >
          <Typography
            variant="h1"
            color="#8396A8"
            fontWeight={700}
            sx={{
              background: "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            display={"flex"}
            alignItems={"center"}
            gap={"10px"}
            marginBottom={"5px"}
            fontSize={"35px"}
          >
            Hailey{" "}
            <CustomizeSpan color="#6941C6">is working on it</CustomizeSpan>
            <CustomizeSpan padding="0px 0px 0px 10px">
              <img src={TrialLoading} alt="Trail-Loading" />
            </CustomizeSpan>
          </Typography>
        </CommonGrid2>
      ) : (
        <>
          <Typography
            variant="h1"
            color="#8396A8"
            fontWeight={700}
            sx={{
              background: "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            marginBottom={"5px"}
            marginTop={"3rem"}
          >
            Hello{" "}
            <CustomizeSpan color="#6941C6" textTransform="capitalize">
              {localStorageData?.username}
            </CustomizeSpan>
          </Typography>
          <Typography
            variant="h1"
            fontSize={"30px"}
            color="#8396A8"
            marginTop={"0.5rem"}
          >
            Upload your file to analyze !
          </Typography>

          <CustomDiv width="100%" margin="4rem 0px 0px">
            <Box width={"70%"} margin={"auto"}>
              <FileUpload
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
                onChange={onChange}
                isDragging={isDragging}
                files={files}
                handleDeleteFile={handleDeleteFile}
                disabled={klarityData.loading}
                fileText={".xls or .xlsx"}
              />

              <CommonButton
                width={"100%"}
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="600"
                value="Generate Analyze"
                padding={"10px 0px"}
                onClick={handleAnalyzeClick}
                loading={klarityData.loading}
                disabled={klarityData.disabled || files.length === 0}
              />
            </Box>
          </CustomDiv>
        </>
      )}
    </CustomDiv>
  );
}
